import { getAlarmQuery } from '@akin-home/alarms/frontend';
import { getAlertQuery } from '@akin-home/alerts/frontend';
import { CalendarItemType } from '@akin-home/amplify';
import { getEventQuery } from '@akin-home/events/frontend';
import { getMealQuery } from '@akin-home/meals/frontend';

interface Params {
  id: string;
  type?: CalendarItemType;
}

/** This funciton can get any calendar item */
export const getCalendarItem = async ({ id, type }: Params) => {
  switch (type) {
    case CalendarItemType.Event:
      return getEventQuery(id);
    case CalendarItemType.Alert:
      return getAlertQuery(id);
    case CalendarItemType.Alarm:
      return getAlarmQuery(id);
    case CalendarItemType.Meal:
      return getMealQuery({
        id,
      });
    default: {
      const results = await Promise.all([
        getEventQuery(id),
        getAlertQuery(id),
        getAlarmQuery(id),
      ]);

      return results[0] || results[1] || results[2];
    }
  }
};
